var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"height":"100%","width":"100%","src":`${_vm.getFilePath}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }